/**
 * Name Directory - Single Audio File Player
 * Plays one MP3 with all language pronunciations
 */

(function() {
  'use strict';
  
  // Single audio element for all playback
  const audioPlayer = new Audio();
  let currentButton = null;
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const audioButtons = document.querySelectorAll('.product-card--name .audio-play-btn');
    
    if (audioButtons.length === 0) {
      return; // No name products on this page
    }
    
    audioButtons.forEach(button => {
      button.addEventListener('click', handleAudioClick);
    });
    
    audioPlayer.addEventListener('ended', handleAudioEnd);
    
    console.log(`Name Directory: ${audioButtons.length} audio buttons initialized`);
  }
  
  function handleAudioClick(e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent navigation
    
    const button = e.currentTarget;
    const audioUrl = button.dataset.audio;
    const nameName = button.dataset.name;
    
    if (!audioUrl) {
      console.error('No audio URL found');
      return;
    }
    
    // Toggle play/pause if clicking same button
    if (currentButton === button && !audioPlayer.paused) {
      audioPlayer.pause();
      button.classList.remove('playing');
      button.querySelector('.audio-text').textContent = 'Hear pronunciation';
      currentButton = null;
      return;
    }
    
    // Stop current playback
    if (currentButton) {
      currentButton.classList.remove('playing');
      currentButton.querySelector('.audio-text').textContent = 'Hear pronunciation';
    }
    
    audioPlayer.pause();
    audioPlayer.currentTime = 0;
    
    // Play new audio
    audioPlayer.src = audioUrl;
    button.classList.add('playing');
    button.querySelector('.audio-text').textContent = 'Playing...';
    currentButton = button;
    
    audioPlayer.play()
      .then(() => {
        console.log(`Playing pronunciation for: ${nameName}`);
        
        // Analytics tracking
        if (typeof gtag !== 'undefined') {
          gtag('event', 'audio_play', {
            'event_category': 'Name Directory',
            'event_label': nameName,
            'value': 1
          });
        }
      })
      .catch(error => {
        console.error('Audio playback failed:', error);
        button.classList.remove('playing');
        button.querySelector('.audio-text').textContent = 'Hear pronunciation';
        currentButton = null;
      });
  }
  
  function handleAudioEnd() {
    if (currentButton) {
      currentButton.classList.remove('playing');
      currentButton.querySelector('.audio-text').textContent = 'Hear pronunciation';
      currentButton = null;
    }
  }
  
  // Keyboard: Escape to stop
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && currentButton) {
      audioPlayer.pause();
      currentButton.classList.remove('playing');
      currentButton.querySelector('.audio-text').textContent = 'Hear pronunciation';
      currentButton = null;
    }
  });
  
})();

// Product Page Audio Player
(function() {
  function initProductPageAudio() {
    const audioButton = document.querySelector('.product-audio-player .audio-play-button');
    
    if (!audioButton) return;
    
    const audioUrl = audioButton.dataset.audio;
    const playIcon = audioButton.querySelector('.play-icon');
    const pauseIcon = audioButton.querySelector('.pause-icon');
    const buttonText = audioButton.querySelector('.button-text');
    const audio = new Audio(audioUrl);
    
    audioButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (audio.paused) {
        audio.play();
        audioButton.classList.add('playing');
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
        buttonText.textContent = 'Playing...';
      } else {
        audio.pause();
        audioButton.classList.remove('playing');
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        buttonText.textContent = 'Play Pronunciation';
      }
    });
    
    audio.addEventListener('ended', function() {
      audioButton.classList.remove('playing');
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      buttonText.textContent = 'Play Again';
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPageAudio);
  } else {
    initProductPageAudio();
  }
})();
